import { api_configuration } from "../../common";
import api_app = api_configuration.libraries.gui_definition_lib.libraries.model_lib.types.application.alan_api;
import api_cs = api_configuration.types.client_state.alan_api;
import { createIdPathBuilderFromNode } from "../navigation/createIdPathFromNode";
import { DatastoreProxy } from "../interface/DatastoreProxy";

function onlyEqualityTodo(user_requirement: api_app.Cuser_requirement): boolean {
	return (
		user_requirement.properties.expression.properties.type.switch<boolean>({
			equality: true,
			existence: false,
			containment: false,
		}) &&
		user_requirement.properties.has_alternative.switch<boolean>({
			no: true,
			yes: ($) => onlyEqualityTodo($.properties.alternative),
		})
	);
}

function determineAndTodo(user_requirement: api_app.Cuser_requirement): api_cs.Tcurrent_user["and"] {
	return onlyEqualityTodo(user_requirement) ? ["no one else", {}] : ["others", {}];
}

export function updateTodo(todo: api_cs.Cyes__todo): void {
	DatastoreProxy.instance
		.collectionQuery({
			"context node path": createIdPathBuilderFromNode(todo.parent).build(),
			filters: {
				"todo filter": [
					"yes",
					{
						path: {
							"has steps": ["no", {}],
						},
					},
				],
				"value filters": {},
			},
			"select entries": "no",
			"collection path": { "has steps": ["no", {}] },
			aggregates: {},
		})
		.then(($) => {
			if (todo.destroyed) return;
			$.properties.context.switch<void>({
				"does not exist": undefined,
				exists: ($) => {
					if ($.properties.amount_of_entries.value > 0) {
						todo.properties.for_.set("current user", {
							and: determineAndTodo(todo.inferences.has_todo().properties.requirement),
						});
					}
				},
				"permission denied": undefined,
			});
		});
}
